// @generated by protobuf-ts 2.11.1 with parameter optimize_code_size,long_type_number
// @generated from protobuf file "bianka/common/activity/v1/page.proto" (package "bianka.common.activity.v1", syntax proto3)
// tslint:disable
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * @generated from protobuf message bianka.common.activity.v1.Page
 */
export interface Page {
    /**
     * Page's name
     *
     * @generated from protobuf field: string name = 1
     */
    name: string;
    /**
     * Data regarding to the page arrived from
     *
     * @generated from protobuf field: bianka.common.activity.v1.Page referrer = 2
     */
    referrer?: Page;
    /**
     * Page's context id represented by contexto's traceId of the render request
     *
     * @generated from protobuf field: string ctx_id = 3
     */
    ctxId: string;
}
// @generated message type with reflection information, may provide speed optimized methods
class Page$Type extends MessageType<Page> {
    constructor() {
        super("bianka.common.activity.v1.Page", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "referrer", kind: "message", T: () => Page },
            { no: 3, name: "ctx_id", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<Page>): Page {
        const message = globalThis.Object.create((this.messagePrototype!));
        message.name = "";
        message.ctxId = "";
        if (value !== undefined)
            reflectionMergePartial<Page>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Page): Page {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* bianka.common.activity.v1.Page referrer */ 2:
                    message.referrer = Page.internalBinaryRead(reader, reader.uint32(), options, message.referrer);
                    break;
                case /* string ctx_id */ 3:
                    message.ctxId = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Page, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* bianka.common.activity.v1.Page referrer = 2; */
        if (message.referrer)
            Page.internalBinaryWrite(message.referrer, writer.tag(2, WireType.LengthDelimited).fork(), options).join();
        /* string ctx_id = 3; */
        if (message.ctxId !== "")
            writer.tag(3, WireType.LengthDelimited).string(message.ctxId);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message bianka.common.activity.v1.Page
 */
export const Page = new Page$Type();
